export class Page {
  name: string;
  url: string;
  constructor(name: string, url: string) {
    this.name = name;
    this.url = url;
  }

	isSameUrl = (url: string) => {
		// check if the page url has any placeholders (e.g. /auth-redirect/:providerId)
		// and take that into account when comparing
		const pageUrlParts = this.url.split("/");
		const urlParts = url.split("/");
		if (pageUrlParts.length !== urlParts.length) {
			return false;
		}
		for (let i = 0; i < pageUrlParts.length; i++) {
			if (pageUrlParts[i].startsWith(":")) {
				continue;
			}
			if (pageUrlParts[i] !== urlParts[i]) {
				return false;
			}
		}
		return true;
	}

	withPlaceholders = (placeholders: string[]) => {
		let url = this.url;
		placeholders.forEach((placeholder) => {
			url = url.replace(/:[^/]+/, placeholder);
		});
		return url;
	}
}

// Get landing URL from env
import env from "./env";

// Auth routes (root level on Dash)
const OAUTH_AUTHORIZE_PAGE = new Page("OAuth Authorize", "/oauth/authorize");
const AUTH_REDIRECT_PAGE = new Page("Auth redirect", "/auth-redirect/:providerId");
const SIGN_IN_PAGE = new Page("Sign In", "/signin");
const SIGN_UP_PAGE = new Page("Sign Up", "/signup");
const ACTIONS_PAGE = new Page("Actions", "/actions");
const ACTION_AUTH_PAGE = new Page("Action Auth", `${ACTIONS_PAGE.url}/auth`);
const CONNECT_PAGE = new Page("Connect Add On", "/connect");

// App routes (authenticated pages under /app)
const APP_PAGE = new Page("App", "/app");
const APP_ADD_ONS_PAGE = new Page("Add-ons", `${APP_PAGE.url}/add-ons`);
const APP_PLUTIO_CREDITS_SETUP_PAGE = new Page("Plutio Credits", `${APP_PAGE.url}/plutio-credits/setup`);
const APP_RESOURCES_PAGE = new Page("Resources", `${APP_PAGE.url}/resources`);
const APP_INTEGRATIONS_PAGE = new Page("Integrations", `${APP_PAGE.url}/integrations`);
const APP_CLIENTS_PAGE = new Page("Clients", `${APP_PAGE.url}/clients`);
const APP_ACCOUNT_PAGE = new Page("Account", `${APP_PAGE.url}/account`);
const APP_BILLING_PAGE = new Page("Billing", `${APP_PAGE.url}/billing`);

// External pages (on Landing site) - full URLs
const HOME_PAGE = new Page("Home", `${env.LANDING_URL}/`);
const PRICING_PAGE = new Page("Pricing", `${env.LANDING_URL}/pricing`);
const EXPLORE_ADD_ONS_PAGE = new Page("Explore Add-Ons", `${env.LANDING_URL}/explore`);
const HELP_PAGE = new Page("Help", `${env.LANDING_URL}/help-center`);
const TERMS_OF_SERVICE_PAGE = new Page("Terms of Service", `${env.LANDING_URL}/terms-of-service`);
const PRIVACY_POLICY_PAGE = new Page("Privacy Policy", `${env.LANDING_URL}/privacy-policy`);
const REFUND_POLICY_PAGE = new Page("Refund Policy", `${env.LANDING_URL}/refund-policy`);
const ABOUT_PAGE = new Page("About", `${env.LANDING_URL}/about`);
const DOCS_PAGE = new Page("Docs", `${env.LANDING_URL}/docs`);

// Fallback pages
const DEFAULT_NOT_AUTHED_FALLBACK_PAGE = SIGN_IN_PAGE;
const DEFAULT_AUTHED_FALLBACK_PAGE = APP_PAGE;
const PAGE_NOT_FOUND_PAGE = new Page("Page Not Found", "/404");

const APP_PAGES = {
  APP_ADD_ONS_PAGE,
  APP_PLUTIO_CREDITS_SETUP_PAGE,
  APP_RESOURCES_PAGE,
  APP_INTEGRATIONS_PAGE,
  APP_CLIENTS_PAGE,
  APP_ACCOUNT_PAGE,
  APP_BILLING_PAGE,
};

const EXTERNAL_PAGES = {
  HOME_PAGE,
  PRICING_PAGE,
  EXPLORE_ADD_ONS_PAGE,
  HELP_PAGE,
  TERMS_OF_SERVICE_PAGE,
  PRIVACY_POLICY_PAGE,
  REFUND_POLICY_PAGE,
  ABOUT_PAGE,
  DOCS_PAGE,
};

const ALL_PAGES = {
  OAUTH_AUTHORIZE_PAGE,
  AUTH_REDIRECT_PAGE,
  SIGN_IN_PAGE,
  SIGN_UP_PAGE,
  ACTIONS_PAGE,
  ACTION_AUTH_PAGE,
  CONNECT_PAGE,
  APP_PAGE,
  PAGE_NOT_FOUND_PAGE,
};

const urlToPage = (url: string): Page => {
  const page = Object.values(ALL_PAGES).find((page) => page.isSameUrl(url));
  if (page) {
    return page;
  } else if (url.startsWith(APP_PAGE.url)) {
    return APP_PAGE;
  }
  return PAGE_NOT_FOUND_PAGE;
};

const pages = {
  ...ALL_PAGES,
  ...APP_PAGES,
  ...EXTERNAL_PAGES,
  DEFAULT_NOT_AUTHED_FALLBACK_PAGE,
  DEFAULT_AUTHED_FALLBACK_PAGE,
  urlToPage,
};

export default pages;
